var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-table',{staticClass:"px-6 elevation-1",attrs:{"headers":_vm.headers,"items":_vm.rows,"items-per-page":_vm.readonly ? -1 : 30,"loading":_vm.loading,"hide-default-footer":_vm.readonly,"search":_vm.searchQuery},scopedSlots:_vm._u([{key:"item.date",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm._f("formatDate")(item.date))+" ")]}},{key:"item.serviceExpenses",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(item.serviceExpenses.length > 0 ? "Да" : "Не")+" ")]}},(!_vm.readonly)?{key:"item.actions",fn:function(ref){
var item = ref.item;
return [(!item.serviceVisitId && _vm.checkIfUserHasPermission(['service-update']))?_c('router-link',{attrs:{"to":{
        name: 'edit-service-machine-rows',
        params: { machineId: item.machineId, id: item.id },
        query: _vm.$route.query
      }}},[_c('v-btn',{staticClass:"mr-2",attrs:{"fab":"","dark":"","x-small":""}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("mdi-pencil")])],1)],1):_vm._e()]}}:null],null,true)})}
var staticRenderFns = []

export { render, staticRenderFns }